import { useEffect, useLayoutEffect, useState } from "react";
import { uiStateActions } from "../store/ui-state";

import useLocalStorage2 from "./useLocalStorage2";
import { useDispatch } from "react-redux";

function useDarkMode(defaultValue = "light") {
  const [enabledState, setEnabledState] = useLocalStorage2(
    "dark-theme",
    defaultValue
  );

  const dispatch = useDispatch();

  let theme = enabledState != undefined ? enabledState : defaultValue;

  // Fire off effect that add/removes dark mode class
  useEffect(() => {
    document.documentElement.setAttribute("color-scheme", theme);
  }, [theme]);
  useEffect(() => {
    dispatch(uiStateActions.setDarkTheme(theme == "dark" ? true : false));
  }, [theme]);

  return [theme, setEnabledState];
}

export default useDarkMode;
